if (!customElements.get('bc-video')) {
  class BcVideo extends HTMLElement {
    connectedCallback() {
      this._video = this.querySelector('video');
      this._poster = this.querySelector('.bc-mv__poster, .bc-vwt__poster');
      this._playBtn = this.querySelector('.bc-mv__play, .bc-vwt__play');
      this._info = this.querySelector('.bc-mv__info');
      this._muteBtn = this.querySelector('.bc-vwt__mute');

      if (!this._video) return;

      if (this.dataset.poster) {
        this._video.poster = this.dataset.poster;
      }

      this._onClick = this._handleClick.bind(this);
      this._onPlay = this._onVideoPlay.bind(this);
      this._onPause = this._onVideoPause.bind(this);
      this._onEnded = this._onVideoEnded.bind(this);
      this._onOtherPlay = this._handleOtherPlay.bind(this);

      this.addEventListener('click', this._onClick);
      this._video.addEventListener('play', this._onPlay);
      this._video.addEventListener('pause', this._onPause);
      this._video.addEventListener('ended', this._onEnded);

      if (this._muteBtn) {
        this._onMuteToggle = (e) => {
          e.stopPropagation();
          this._toggleMute();
        };
        this._muteBtn.addEventListener('click', this._onMuteToggle);
        this._syncMuteButton();
      }

      this._io = new IntersectionObserver(
        (entries) => {
          if (!entries[0].isIntersecting && !this._video.paused) {
            this._video.pause();
          }
        },
        { threshold: 0.2 }
      );
      this._io.observe(this);

      document.addEventListener('bc-video:play', this._onOtherPlay);
    }

    disconnectedCallback() {
      this._io?.disconnect();
      document.removeEventListener('bc-video:play', this._onOtherPlay);
      if (this._muteBtn && this._onMuteToggle) {
        this._muteBtn.removeEventListener('click', this._onMuteToggle);
      }
    }

    _handleClick(e) {
      if (e.target.closest('.bc-mv__info, .bc-vwt__mute')) return;

      if (this._video.paused) {
        this._startPlay();
      } else {
        this._video.pause();
      }
    }

    _startPlay() {
      document.dispatchEvent(new CustomEvent('bc-video:play', { detail: { source: this } }));
      this._video.play().catch(() => {});
    }

    _onVideoPlay() {
      this.setAttribute('data-playing', '');
      if (this._info) this._info.setAttribute('aria-hidden', 'true');
      if (this._poster) this._poster.setAttribute('aria-hidden', 'true');
      if (this._playBtn) {
        this._playBtn.setAttribute('aria-hidden', 'true');
        this._playBtn.setAttribute('aria-pressed', 'true');
      }
      this._showMuteButton(true);
      this._syncMuteButton();
    }

    _onVideoPause() {
      this.removeAttribute('data-playing');
      if (this._info) this._info.removeAttribute('aria-hidden');
      if (this._poster) this._poster.removeAttribute('aria-hidden');
      if (this._playBtn) {
        this._playBtn.removeAttribute('aria-hidden');
        this._playBtn.setAttribute('aria-pressed', 'false');
      }
      this._showMuteButton(false);
    }

    _onVideoEnded() {
      this._video.currentTime = 0;
      this._onVideoPause();
    }

    _handleOtherPlay(e) {
      if (e.detail.source !== this && !this._video.paused) {
        this._video.pause();
      }
    }

    _toggleMute() {
      if (!this._video) return;
      this._video.muted = !this._video.muted;
      if (!this._video.muted) this._video.volume = 1;
      this._syncMuteButton();
    }

    _syncMuteButton() {
      if (!this._muteBtn) return;
      const muted = !this._video || this._video.muted;
      this._muteBtn.classList.toggle('is-muted', muted);
      this._muteBtn.setAttribute('aria-pressed', String(muted));
      this._muteBtn.setAttribute('aria-label', muted ? 'Unmute video' : 'Mute video');
    }

    _showMuteButton(show) {
      if (this._muteBtn) this._muteBtn.hidden = !show;
    }
  }

  customElements.define('bc-video', BcVideo);
}
